import ApprovalType from './ApprovalType'
import Employee from './Employee'
import SalesOffice from './SalesOffice'
import EquipmentClass from './EquipmentClass'
export class SalesOfficeApprover {
    ID: number;
    EmployeeID: number;
    SalesOfficeID: number;
    ApprovalTypeID: number;
    EquipmentClassID?: number;
    Inactive: boolean;
    Employee: Employee;
    SalesOffice: SalesOffice;
    ApprovalType: ApprovalType;
    EquipmentClass: EquipmentClass;
}

export default SalesOfficeApprover;
